export enum MainService {
  Websites = "Websites",
  ItConsulting = "ItConsulting",
  SoftwareDevelopment = "SoftwareDevelopment",
}
